<template>
  <v-container>
    <v-row>
      <v-col class="d-flex flex-row align-center">
        <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>{{formData.firstName}} {{formData.lastName}}</h1>
        <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
        ></v-progress-circular>
        <span v-else class="ml-5">
          <v-btn color="info" class="mr-2" @click="openAltMenu">Events</v-btn>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="d-flex flex-column">
        <span class="mb-5">
          <v-btn @click="isEditable = !isEditable">
            <span v-if="isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </span>
        <v-form :disabled="!isEditable" v-model="validData">
          <v-text-field
              label="First Name"
              outlined
              :rules="rules.required"
              v-model="formData.firstName"
          />
          <v-text-field
              label="Last Name"
              outlined
              :rules="rules.required"
              v-model="formData.lastName"
          />
          <v-text-field
              label="Phone"
              outlined
              v-model="formData.phone"
          />
          <v-text-field
              label="Email"
              outlined
              v-model="formData.email"
          />
          <span>
                <h3>Address</h3>
                <v-text-field
                    label="Address Line 1"
                    outlined
                    v-model="formData.address.line1"
                />
                <v-text-field
                    label="Address Line 2"
                    outlined
                    v-model="formData.address.line2"
                />
                <v-text-field
                    label="City"
                    outlined
                    v-model="formData.address.city"
                />
                <v-text-field
                    label="Notes"
                    outlined
                    v-model="formData.notes"
                />
              </span>
        </v-form>
        <span>
          <v-btn color="error" @click="deleteRecord">Delete</v-btn>
          <v-btn :loading="formLoader" class="ml-2" :disabled="!isEditable || !validData" color="success" @click="update">Save</v-btn>
        </span>
      </v-col>
      <v-col v-if="showAltMenu">
        <v-card outlined>
          <v-card-title class="d-flex flex-row justify-space-between">
            <span>
              <span>
                Events
              </span>
              <v-btn class="ml-1" color="info" fab x-small @click="createAlt"><v-icon>mdi-plus</v-icon></v-btn>
            </span>
            <span>
              <v-btn class="mr-1" color="success" fab x-small @click="loadAltData"><v-icon>mdi-refresh</v-icon></v-btn>
              <v-btn color="error" fab x-small @click="closeAltMenu"><v-icon>mdi-close</v-icon></v-btn>
            </span>
          </v-card-title>
          <v-card-text>
            <v-data-table
                :headers="altHeaders"
                :items="altData"
                :items-per-page="-1"
                class="elevation-1"
                @click:row="rowClick"
                :loading="altLoader"
            >
              <template v-slot:item.dueDate="{ item }">
                <span>{{ parseDate(item.dueDate) }}</span>
              </template>
              <template v-slot:item.completedDate="{ item }">
                <span>{{ parseDate(item.completedDate) || "Incomplete" }}</span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </v-container>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  import moment from "moment";
  export default {
    data () {
      return {
        loader: false,
        snackObj: {
          color: '',
          text: ''
        },

        rules: {
          required: [v => !!v || 'This field is required.'],
        },
        validData: false,

        altLoader: false,
        altHeaders: [
          { text: 'ID', align: 'start', sortable: true, value: 'id' },
          { text: 'Name', sortable: true, value: 'name' },
          { text: 'Completed At', value: 'completedDate' }
        ],
        altData: [],
        showAltMenu: false,

        formLoader: false,
        formData: {address:{}},
        isEditable: false,

        pluralLower: "customers",
        plural: "Customers",
        singularLower: "customer",
        singular: "Customer"
      }
    },
    async mounted(){
        try {
          this.loader = true;
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error;
          this.formData = res.data.data;

          if(this.$route.query.events){
            await this.openAltMenu();
          }

        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getEndpoint'])
    },
    methods: {
      async update(){
        try {
          this.formLoader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.formData)
          if(res.data.error) throw res.data.error;

          this.snack(`${this.singular} Updated 🎉`);
          this.isEditable = false;
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.formLoader = false;
        }
      },
      async loadAltData(){
        try{
          this.altLoader = true;
          let res = await axios.get(`${this.getEndpoint}/api/events/byCustomer/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error;

          this.altData = res.data.data || [];
        }
        catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
        finally {
          this.altLoader = false;
        }
      },
      async openAltMenu(){
        this.showAltMenu = true;
        await this.loadAltData();
        if(!this.$route.query.events){
          await this.$router.replace({path: `${this.$route.path}`, query: {events: "true"}})
        }
      },
      async closeAltMenu(){
        this.showAltMenu = false;
        if(this.$route.query.events){
          await this.$router.replace({path: `${this.$route.path}`, query: null})
        }
      },
      async createAlt(){
        await this.$router.push(`/events?create=true&customer=${this.$route.params.id}`);
      },
      async deleteRecord(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.data.error) throw res.data.error
          this.snack(`${this.singular} Deleted 🎉`);
          this.$router.go(-1);
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      async rowClick(row){
        await this.$router.push(`/events/view/${row.id}`);
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      parseDate(date){
        if(!date) return null;
        return moment(this.parseISODate(date)).format("DD/MM/YYYY")
      },
      momentDateFormat (date) {
        return date ? moment(this.parseISODate(date)).format('ddd, MMM Do YYYY') : '';
      },
      parseISODate(date){
        return (date?new Date(date).toISOString().substring(0, 10):null);
      },
    }
  }
</script>
